module.exports = __webpack_public_path__ + "img/photo_2023-11-27 11.39.46.bd688136.jpg";